import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  makeStyles,
} from "@material-ui/core";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";
import DayJsUtils from "@date-io/dayjs";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import dayjs from "dayjs";
import localeEl from "dayjs/locale/el";
import localeEn from "dayjs/locale/en";
import useLocale from "../../../hooks/useLocale";
import { useState } from "react";
import GovGrButton from "../../../components/GovGrButton";

const useStyles = makeStyles({
  dialog: {
    height: 150,
  },
  dateContainer: {
    width: "100%",
  },
});

const RejectionModal = ({
  open,
  close,
  refetch,
  values,
  submit,
  setFieldValue,
}) => {
  const classes = useStyles();
  const [error, setError] = useState("");
  const { t, locale } = useLocale();
  dayjs().locale(locale === "el-GR" ? localeEl : localeEn);
  // Mutation for creating data

  return (
    <MuiPickersUtilsProvider
      locale={locale === "el-GR" ? localeEl : localeEn}
      utils={DayJsUtils}
    >
      <CustomDialog
        open={open}
        maxWidth="sm"
        onClose={() => {
          close();
          setError("");
        }}
      >
        <DialogTitle id="form-dialog-title">{t("Warning")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("Are you sure you want to reject the application?")}
          </DialogContentText>
        </DialogContent>
        <CustomAlert
          open={!!error}
          close={() => {
            setError("");
          }}
          message={t("A network error occured, please try again later")}
        />

        <DialogActions>
          <GovGrButton
            onClick={() => {
              submit();
              close();
            }}
            color="primary"
            buttonText={t("Reject application")}
          />
          <GovGrButton
            onClick={() => {
              close();
              setError("");
            }}
            color="primary"
            buttonText={t("Cancel")}
          />
        </DialogActions>
      </CustomDialog>
    </MuiPickersUtilsProvider>
  );
};

export default RejectionModal;
